module.exports = __webpack_public_path__ + "img/camel-comb1-1.0bea17c2.jpg";